import BaseCtrl from 'edge/platform/base/BaseCtrl';
import _ from 'lodash';

const fn = ($filter, $scope, $rootScope, $state, $stateParams, $window, ModalService, AccountService, gatewayParamConfig, UserInfoService) => {
    const ctrl = Object.create(BaseCtrl);

    init();

    function init() {
        $scope.selectedProducerCode = {};
        $scope.loadingAccounts = true;
        $scope.loadingComplete = false;
        $scope.pageSize = gatewayParamConfig.accountLandingResultsPerPage;


        $scope.recentlyViewedFilter = {
            'name': 'recentlyViewed',
            'displayKey': 'gateway.views.account-landing.Recently Viewed'
        };
        $scope.recentlyCreatedFilter = {
            'name': 'recentlyCreated',
            'displayKey': 'gateway.views.account-landing.Recently Created'
        };
        $scope.personalAccountsFilter = {
            'name': 'personalAccounts',
            'displayKey': 'gateway.views.account-landing.Personal Accounts'
        };
        $scope.commercialAccountsFilter = {
            'name': 'commercialAccounts',
            'displayKey': 'gateway.views.account-landing.Commercial Accounts'
        };
        $scope.accountFilters = [
            $scope.recentlyViewedFilter,
            $scope.recentlyCreatedFilter,
            $scope.personalAccountsFilter,
            $scope.commercialAccountsFilter
        ];

        initQueryOptions();

        $scope.currentAccountFilter = $scope.recentlyViewedFilter;

        setActiveQuickFilter();
        setAccountsTableLabel();
    }

    function initQueryOptions() {
        $scope.queryOptions = {
            offsetStart: 0,
            offsetEnd: $scope.pageSize - 1,
            orderBy: 'CreateTime',
            orderByDescending: true
        };
    }

    function getRecentlyViewedAccounts() {
        return AccountService.getRecentlyViewedAccounts();
    }

    function getAccountsForCurrentUser(queryParam) {
        return AccountService.getAccountsForCurrentUser(gatewayParamConfig.accountsCreatedInLastXDays, $scope.queryOptions, queryParam);
    }

    function getPersonalAccountsForCurrentUser(queryParam) {
        return AccountService.getPersonalAccountsForCurrentUser(gatewayParamConfig.accountsCreatedInLastXDays, $scope.queryOptions, queryParam);
    }

    function getCommercialAccountsForCurrentUser(queryParam) {
        return AccountService.getCommercialAccountsForCurrentUser(gatewayParamConfig.accountsCreatedInLastXDays, $scope.queryOptions, queryParam);
    }

    function getAccountsForProducerCode() {
        return AccountService.getAccountsForProducerCode(gatewayParamConfig.accountsCreatedInLastXDays, $scope.queryOptions, $scope.selectedProducerCode.code);
    }

    function getPersonalAccountsForProducerCode() {
        return AccountService.getPersonalAccountsForProducerCode(gatewayParamConfig.accountsCreatedInLastXDays, $scope.queryOptions, $scope.selectedProducerCode.code);
    }

    function getCommercialAccountsForProducerCode() {
        return AccountService.getCommercialAccountsForProducerCode(gatewayParamConfig.accountsCreatedInLastXDays, $scope.queryOptions, $scope.selectedProducerCode.code);
    }

    function getAccountSummaries(accounts) {
        const accountSummaries = [];
        if (angular.isDefined(accounts) && accounts.length > 0) {
            accounts.forEach((account) => {
                const accountSummary = {
                    account: account.accountHolder,
                    accountNumber: account.accountNumber,
                    policies: getAccountPolicySummaries(account),
                    producerCodes: account.producerCodes,
                    createdDate: account.accountCreatedDate,
                    address: account.accountHolderAddress,
                    openActivities: account.numberOfOpenActivities,
                    isCommercial: account.isCommercialAccount,
                    isPersonal: account.isPersonalAccount,
                    createdByMe: account.createdByMe
                };

                accountSummaries.push(accountSummary);
            });
        }

        return accountSummaries;
    }

    function getAccountPolicySummaries(account) {
        const policySummaries = [];
        if (angular.isDefined(account.policySummaries) && account.policySummaries.length > 0) {
            account.policySummaries.forEach((policySummary) => {
                const policy = {
                    policyNumber: policySummary.policyNumber,
                    lineOfBusiness: policySummary.policyLines[0].lineOfBusinessName
                };

                policySummaries.push(policy);
            });
        }

        return policySummaries;
    }

    $scope.setCurrentFilter = (filter) => {
        if (filter && filter !== $scope.currentAccountFilter) {
            $scope.currentAccountFilter = filter;
            setActiveQuickFilter();
            initQueryOptions();
        }
        setAccountsTableLabel();
    };

    function updateAccountsList(producerCode, currentFilter) {
        let queryParam;
        if (producerCode === 'myWork') {
            queryParam = {
                propertyName: 'CreateUser',
                entityName: 'User',
                entityPublicId: UserInfoService.publicId,
                isDbProperty: true,
                orOperation: false
            };
        }

        let requestService;
        if (currentFilter === $scope.recentlyViewedFilter) {
            return getRecentlyViewedAccounts().then(
                accounts => {
                    $scope.allAccounts = getAccountSummaries(accounts);
                    $scope.loadingAccounts = false;

                    return {
                        'items': $scope.allAccounts,
                        'maxNumberOfResults': 0
                    };
                },
                () => {
                    $scope.loadingAccounts = false;
                }
            );
        }
        const isProducerCodeNotSpecific = ['all', 'myWork'].indexOf(producerCode) > -1;
        if (currentFilter === $scope.recentlyCreatedFilter) {
            requestService = isProducerCodeNotSpecific ? getAccountsForCurrentUser([queryParam]) : getAccountsForProducerCode();
            return requestAccounts(requestService);
        } else if (currentFilter === $scope.personalAccountsFilter) {
            requestService = isProducerCodeNotSpecific ? getPersonalAccountsForCurrentUser([queryParam]) : getPersonalAccountsForProducerCode();
            return requestAccounts(requestService);
        } else if (currentFilter === $scope.commercialAccountsFilter) {
            requestService = isProducerCodeNotSpecific ? getCommercialAccountsForCurrentUser([queryParam]) : getCommercialAccountsForProducerCode();
            return requestAccounts(requestService);
        }
    }

    function requestAccounts(requestService) {
        return requestService.then(
            (accounts) => {
                $scope.allAccounts = getAccountSummaries(accounts.accounts);
                $scope.loadingAccounts = false;

                return {
                    'items': $scope.allAccounts,
                    'maxNumberOfResults': accounts.maxNumberOfResults
                };
            },
            () => {
                $scope.loadingAccounts = false;
            }
        );
    }

    function setActiveQuickFilter() {
        $scope.recentlyViewedFilterActive = ($scope.currentAccountFilter === $scope.recentlyViewedFilter);
        $scope.recentlyCreatedFilterActive = ($scope.currentAccountFilter === $scope.recentlyCreatedFilter);
        $scope.personalAccountsFilterActive = ($scope.currentAccountFilter === $scope.personalAccountsFilter);
        $scope.commercialAccountsFilterActive = ($scope.currentAccountFilter === $scope.commercialAccountsFilter);
    }

    function setAccountsTableLabel() {
        $scope.accountsTableLabel = $scope.currentAccountFilter.displayKey;
    }

    const _getLoadByOffset = _.memoize((producerCode, currentFilter) => {
        return (offsetStart, offsetEnd) => {
            $scope.queryOptions.offsetStart = offsetStart;
            $scope.queryOptions.offsetEnd = offsetEnd;

            return updateAccountsList(producerCode, currentFilter);
        };
    }, (producerCode, currentFilter) => producerCode + currentFilter.name);
    $scope.getLoadByOffset = function () {
        return _getLoadByOffset($scope.selectedProducerCode.code, $scope.currentAccountFilter);
    };

    $scope.$watch('loadingAccounts', () => {
        $scope.loadingComplete = (!$scope.loadingAccounts);
    });

    return ctrl.create($scope);
};

fn.$inject = ['$filter', '$scope', '$rootScope', '$state', '$stateParams', '$window', 'ModalService', 'AccountService', 'gatewayParamConfig', 'UserInfoService'];
export default fn;